<template>
  <nav class="navbar bg-body-tertiary fixed-top custom-navbar shadow-sm">
    <div class="container-fluid align-items-center">
      <a class="navbar-brand" href="#">
        <img :src="logo" alt="Logo" class="img-fluid" width="90" />
      </a>

      <div class="flex-grow-1 d-flex justify-content-center">
        <span v-if="isPreviewEnv" class="local-flag text-uppercase">Test Area</span>
      </div>

      <div class="ms-auto d-flex align-items-center gap-3 navbar-actions">
        <div v-if="showLanguageSelector" class="navbar-controls-stack">
          <div v-if="showLanguageSelector" class="language-selector">
            <select
                v-model="selectedLang"
                class="form-select form-select-sm"
                @change="changeLanguage"
            >
              <option v-for="lang in supportedLanguages" :key="lang.code" :value="lang.code">
                {{ lang.label }}
              </option>
            </select>
          </div>
        </div>

        <NotificationBell v-if="showNotifications" />
        <NavbarMenu v-if="showMenu" />
      </div>
    </div>
  </nav>
</template>

<script>
import logo from '@/assets/logos/logo_tjs_prime_mark_black.png';
import NotificationBell from './NotificationBell.vue';
import NavbarMenu from './NavbarMenu.vue';
import { isPreviewEnv as isPreviewEnvHelper } from '@/services/hostContext';
import { supportedLanguages } from '@/constants/languages';

export default {
  name: 'AppNavbar',
  components: { NotificationBell, NavbarMenu },
  props: {
    showMenu: {
      type: Boolean,
      default: true
    },
    showNotifications: {
      type: Boolean,
      default: true
    },
    showLanguageSelector: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      logo,
      supportedLanguages,
      selectedLang: this.$i18n?.locale || 'en'
    };
  },
  computed: {
    isPreviewEnv() {
      return isPreviewEnvHelper(this.$hostContext && this.$hostContext.env);
    }
  },
  watch: {
    '$i18n.locale'(newLocale) {
      if (newLocale && newLocale !== this.selectedLang) {
        this.selectedLang = newLocale;
      }
    }
  },
  mounted() {
    this.hydrateLanguage();
  },
  methods: {
    hydrateLanguage() {
      const savedLang = localStorage.getItem('lang');
      const codes = this.supportedLanguages.map(lang => lang.code);
      if (savedLang && codes.includes(savedLang)) {
        this.selectedLang = savedLang;
        this.$i18n.locale = savedLang;
      }
    },
    changeLanguage() {
      if (!this.selectedLang) return;
      this.$i18n.locale = this.selectedLang;
      localStorage.setItem('lang', this.selectedLang);
    }
  }
};
</script>

<style scoped>
.custom-navbar {
  z-index: 1030;
}
.navbar-actions {
  flex-wrap: wrap;
  justify-content: flex-end;
}
.navbar-controls-stack {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.35rem;
}
.local-flag {
  font-weight: 700;
  letter-spacing: 1px;
  color: #6c757d;
  opacity: 0.9;
}
.language-selector {
  min-width: 170px;
}
@media (max-width: 767.98px) {
  .navbar-actions {
    gap: 0.75rem;
  }

  .navbar-controls-stack {
    align-items: stretch;
  }

  .language-selector,
  .navbar-controls-stack {
    width: 100%;
    min-width: 0;
  }
}
</style>
